<template>
  <div>
    <div class="overlay-div" v-on:click.stop="handleNegativeAnswer"></div>
    <order-list
      :allowSelection="orderPopUp.allowSelection"
      @elementSelected="handleElementSelection"
      class="order-pop-up background-color"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "orderPopUp",
  data() {
    return {};
  },
  created: function () {
    this.setSelectedPreFilters(this.orderPopUp.preFilters);
    this.setSelectedFilter(undefined);
    window.addEventListener(
      "keyup",
      function (e) {
        if (this.isBlurred) {
          return;
        }
        if (e.keyCode === 27) {
          this.handleNegativeAnswer();
        }
      }.bind(this)
    );
  },
  destroyed: function () {
    this.setSelectedPreFilters(undefined);
    this.setSelectedFilter(undefined);
  },
  computed: {
    ...mapGetters({
      orderPopUp: "orderModule/orderPopUp",
    }),
  },
  methods: {
    ...mapActions({
      setOrderPopUp: "orderModule/setOrderPopUp",
      setSelectedPreFilters: "orderModule/setSelectedPreFilters",
      setSelectedFilter: "orderModule/setSelectedFilter",
    }),
    handleNegativeAnswer: function () {
      if (this.orderPopUp.negativeCallback) {
        this.orderPopUp.negativeCallback();
      }
      this.setOrderPopUp({ isOpen: false });
    },
    handleElementSelection(selectedElement) {
      if (this.orderPopUp.positiveCallback) {
        this.orderPopUp.positiveCallback({ selectedElement: selectedElement });
        this.setOrderPopUp({ isOpen: false });
      }
    },
  },
};
</script>

<style lang="scss">
.order-pop-up {
  border-radius: $border-radius-0;
  position: fixed;
  width: 80%;
  height: 80%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow-y: auto;
}
</style>
